import { memo } from "react";
import Link from "next/link";
import Image from "next/image";
import clsx from "clsx";

import arrowOut from "@public/arrow_out.svg";

import s from "./styles.module.css";

interface SectionLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  isExternal?: boolean;
  className?: string;
}

interface LinkViewProps {
  isExternal?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const LinkView = ({ children, isExternal, ...props }: LinkViewProps) => (
  <span {...props}>
    {children}&nbsp;
    {isExternal ? <Image src={arrowOut} alt="arrow external link icon" /> : "→"}
  </span>
);

function SectionLink({
  children,
  className,
  href,
  ...props
}: SectionLinkProps) {
  return (
    <Link href={href || "/"}>
      <LinkView {...props} className={clsx(s.link, className)}>
        {children}
      </LinkView>
    </Link>
  );
}

export default memo(SectionLink);
